import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash/fp';
import classnames from 'classnames';

import { isDesktop } from '../../../../config';
import styles from './section.module.css';
import SectionTitle from '../SectionTitle/index';

class Section extends Component {
  static propTypes = {
    content: PropTypes.arrayOf(PropTypes.string),
    title: PropTypes.string.isRequired,
    className: PropTypes.string,
  };
  state = {
    showMore: false,
  };
  getContent = (content, limit) => {
    if (content.length <= limit || this.state.showMore) {
      return content;
    }
    return content.slice(0, limit);
  };
  toggle = () => {
    this.setState({ showMore: !this.state.showMore });
  };
  render() {
    const { content, title, className } = this.props;
    const showMore = this.state.showMore;
    const limit = isDesktop() ? 7 : 4;
    return content && content.length > 0 ? (
      <div className={classnames(styles.container, className)}>
        <SectionTitle title={title} />
        <div className={styles.content}>
          {map(
            l => (
              <span className={styles.item} key={l}>
                {l}
              </span>
            ),
            this.getContent(content, limit),
          )}
          {content.length > limit && (
            <span className={styles.readMore} onClick={this.toggle}>
              {' '}
              See {showMore ? ' less' : ' more'}{' '}
            </span>
          )}
        </div>
      </div>
    ) : null;
  }
}

export default Section;
